<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<header
  class="h-16 px-6 md:px-8 border-b border-gray-200 flex items-center justify-between shrink-0 bg-white z-30 relative">
  <div class="flex items-center gap-4">
    <h1 class="font-spartan text-2xl font-bold tracking-tight">
      <span class="text-[#2E3B85]">Mind</span><span class="text-[#0084C4]">Play</span>
      <span class="text-[#2E3B85]"> Teacher Academy</span>
    </h1>
  </div>

  <div class="flex items-center gap-5 relative">
    <a
      href="https://help.mindplay.com/"
      target="_blank"
      rel="noopener noreferrer"
      class="text-gray-400 hover:text-[#0084C4] transition-colors">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        data-lucide="help-circle"
        aria-hidden="true"
        class="lucide lucide-help-circle w-5 h-5">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
        <path d="M12 17h.01"></path>
      </svg>
    </a>
    <div class="w-px h-6 bg-gray-200"></div>

    <!-- User Profile Dropdown Toggle -->
    <div class="relative">
      <div
        id="user-menu-btn"
        class="flex items-center gap-3 cursor-pointer group"
        (click)="toggleUserMenu($event)"
        [attr.aria-expanded]="isUserMenuOpen"
        aria-haspopup="true">
        <div class="text-right sm:block">
          <p
            class="text-sm font-bold text-[#1E2952] leading-none group-hover:text-[#0084C4] transition-colors">
            {{ displayName }}
          </p>
          @if (displaySchool) {
            <p class="text-xs text-gray-500 mt-1">{{ displaySchool }}</p>
          }
        </div>
        <div
          class="w-9 h-9 rounded-full bg-[#0084C4] text-white flex items-center justify-center font-bold text-sm shadow-sm group-hover:scale-105 transition-transform">
          {{ initials }}
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          data-lucide="chevron-down"
          aria-hidden="true"
          class="lucide lucide-chevron-down block w-4 h-4 shrink-0 text-gray-400 group-hover:text-[#0084C4] transition-colors"
          [class.rotate-180]="isUserMenuOpen">
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </div>

      <!-- Dropdown Menu -->
      @if (isUserMenuOpen) {
        <div
          id="user-dropdown"
          class="absolute right-0 mt-3 w-72 bg-white rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.15)] border border-gray-100 z-50 overflow-hidden transform transition-all origin-top-right"
          (click)="$event.stopPropagation()">
          <div class="p-4 border-b border-gray-100 bg-gray-50/50">
            <div class="flex items-center gap-3">
              <div
                class="w-12 h-12 rounded-full bg-[#0084C4] text-white flex items-center justify-center font-bold text-lg shadow-sm shrink-0">
                {{ initials }}
              </div>
              <div>
                <p class="text-[15px] font-bold text-[#1E2952] leading-tight">{{ displayName }}</p>
                @if (displayEmail) {
                  <p class="text-xs text-[#757575] mt-0.5">{{ displayEmail }}</p>
                }
              </div>
            </div>
          </div>

          <div class="p-2 border-b border-gray-100">
            @if (
              !isLoadingLicenseInfo && licenseInfo && !licenseInfo.IsStripeCustomer && activeLicense
            ) {
              <div class="px-3 py-2.5">
                <p class="text-[10px] font-bold text-[#757575] mb-2 uppercase tracking-wider">
                  Account Information
                </p>
                <div class="flex items-center gap-2.5 text-sm text-[#424242]">
                  <div
                    class="w-7 h-7 rounded-md bg-[#E8EAF6] flex items-center justify-center text-[#2E3B85]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      data-lucide="building-2"
                      aria-hidden="true"
                      class="lucide lucide-building-2 w-4 h-4">
                      <path d="M10 12h4"></path>
                      <path d="M10 8h4"></path>
                      <path d="M14 21v-3a2 2 0 0 0-4 0v3"></path>
                      <path
                        d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2"></path>
                      <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16"></path>
                    </svg>
                  </div>
                  <div>
                    <p class="font-semibold text-[#1E2952] text-[13px]">
                      {{ activeLicense.ProgramAccessTypeName }}
                    </p>
                    <p class="text-xs text-[#757575]">
                      Active until {{ activeLicense.ExpirationDate | date: 'MMM yyyy' }}
                    </p>
                  </div>
                </div>
              </div>
            }

            @if (
              !isLoadingLicenseInfo && licenseInfo && licenseInfo.IsStripeCustomer && activeCard
            ) {
              <div class="px-3 py-2.5">
                <p class="text-[10px] font-bold text-[#757575] mb-2 uppercase tracking-wider">
                  Payment Method
                </p>
                <div class="flex items-center gap-2.5 text-sm text-[#424242]">
                  <div
                    class="w-7 h-7 rounded-md bg-[#E8F5E9] flex items-center justify-center text-[#2E7D32]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      data-lucide="credit-card"
                      aria-hidden="true"
                      class="lucide lucide-credit-card w-4 h-4">
                      <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                      <line x1="2" x2="22" y1="10" y2="10"></line>
                    </svg>
                  </div>
                  <div>
                    <p class="font-semibold text-[#1E2952] text-[13px]">
                      {{ activeCard.CardBrand || 'Card' }} ending in {{ activeCard.CardLast4 }}
                    </p>
                    @if (activeCardSubscriptions.length === 1) {
                      @if (activeCardSubscriptions[0].PlanName) {
                        <p class="text-[12px] font-semibold text-[#1E2952] mt-0.5">
                          {{ activeCardSubscriptions[0].PlanName }}
                        </p>
                      }
                      @if (activeCardSubscriptions[0].ExpirationDate) {
                        <p class="text-[11px] text-[#757575] mt-0.5">
                          Subscription expires:
                          {{ activeCardSubscriptions[0].ExpirationDate | date: 'MMM d, yyyy' }}
                        </p>
                      }
                    }
                    @if (activeCardSubscriptions.length > 1) {
                      <p class="text-xs text-[#757575] font-semibold">
                        Subscriptions ({{ activeCardSubscriptions.length }})
                      </p>
                      <div class="mt-1 space-y-1.5">
                        @for (
                          subscription of activeCardSubscriptions;
                          track subscription.SubscriptionId
                        ) {
                          <div>
                            <p class="text-[12px] font-semibold text-[#1E2952]">
                              {{ subscription.PlanName || 'Subscription' }}
                            </p>
                            @if (subscription.ExpirationDate) {
                              <p class="text-[11px] text-[#757575]">
                                Expires {{ subscription.ExpirationDate | date: 'MMM d, yyyy' }}
                              </p>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <button
                  type="button"
                  (click)="openPaymentMethodModal($event)"
                  class="text-xs font-bold text-[#0084C4] hover:text-[#006A9D] mt-2 ml-9 transition-colors">
                  Update Billing Info
                </button>
              </div>
            }
          </div>

          <div class="p-2">
            <button
              type="button"
              (click)="onSignOut()"
              class="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm font-semibold text-[#D32F2F] hover:bg-red-50 rounded-md transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                data-lucide="log-out"
                aria-hidden="true"
                class="lucide lucide-log-out w-4 h-4">
                <path d="m16 17 5-5-5-5"></path>
                <path d="M21 12H9"></path>
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              </svg>
              Sign Out
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</header>

@if (isPaymentMethodModalOpen) {
  <app-account-payment-method
    (canceled)="closePaymentMethodModal()"
    (saved)="onPaymentMethodSaved()">
  </app-account-payment-method>
}
